var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftSolidFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 640 640",
    style: {
      enableBackground: "new 0 0 640 640"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.4,297.4c-12.5,12.5-12.5,32.8,0,45.3l160,160c12.5,12.5,32.8,12.5,45.3,0s12.5-32.8,0-45.3L173.3,352H544 c17.7,0,32-14.3,32-32s-14.3-32-32-32H173.3l105.4-105.4c12.5-12.5,12.5-32.8,0-45.3s-32.8-12.5-45.3,0l-160,160V297.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftSolidFull);
export default __webpack_public_path__ + "static/media/arrow-left-solid-full.510714694b0ddacff1c289e88338bc89.svg";
export { ForwardRef as ReactComponent };